import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Box, Typography } from "@mui/material";

interface OfflineOverlayProps {
  show: boolean;
  message: string;
}

const OverlayMessage: React.FC<OfflineOverlayProps> = ({ show, message }) => {
  if (!show) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Gray transparent background
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999, // Ensure it overlays on top of other content
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center", // Center icon and message horizontally
          textAlign: "center",
          padding: "20px",
          backgroundColor: "rgba(0, 0, 0, 0.7)", // Slightly darker background for text readability
          borderRadius: "8px",
        }}
      >
        <WarningAmberRoundedIcon
          sx={{ fontSize: "58px", color: "white", marginBottom: "10px" }}
        />
        {/* Bigger icon */}
        <Typography
          variant="h6"
          sx={{
            color: "white",
            fontWeight: "bold", // Optionally make the text bold for emphasis
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default OverlayMessage;
